import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Redirect, withRouter } from 'react-router-dom';

import { logoutUser } from '../../../../store/actions';

//redux
import { useDispatch, useSelector } from 'react-redux';
import { APIClient } from '../../../../helpers/api_helper';

const Logout = () => {
  const dispatch = useDispatch();
  const API = new APIClient();
  const { isUserLogout } = useSelector((state) => ({
    isUserLogout: state.Login.isUserLogout,
  }));

  const logoutUserApi = () => {
    API.get('/auth/logout');
  };

  useEffect(() => {
    dispatch(logoutUser());
    logoutUserApi();
  }, [dispatch]);

  if (isUserLogout) {
    return <Redirect to="/login" />;
  }

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);
